<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <div class="arrival-detail wrapper--spacing-vertical" data-test="arrival-detail">
    @if (viewMode === 'general-flock-data') {
      <div class="flex--column">
        <mat-form-field class="flex__child--auto">
          <mat-label for="flockName">{{ 'arrival-detail.flock-name' | translate }}</mat-label>
          <input
            id="flockName"
            matInput
            formControlName="flockName"
            placeholder="{{ 'arrival-detail.flock-name' | translate }}"
            data-test="arrival-detail__flock-name"
          />
          <mat-error *ngIf="formGroup.controls.flockName.invalid">
            {{ 'validation-error.required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'arrival-detail.barn' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            formControlName="barnId"
            data-test="arrival-detail__barn"
          >
            @for (barn of barns(); track barn.id) {
              <mat-option [value]="barn.id">
                {{ barn.name }}
              </mat-option>
            }
          </mat-select>
          <mat-error *ngIf="formGroup.controls.barnId.invalid">
            {{ 'validation-error.required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label for="chickBirthDate">{{
            'arrival-detail.chick-birthdate' | translate
          }}</mat-label>
          <input
            id="chickBirthDate"
            matInput
            formControlName="chickBirthDate"
            [matDatepicker]="chickBirthDatePicker"
            placeholder="{{ 'arrival-detail.chick-birthdate' | translate }}"
            (focus)="chickBirthDatePicker.open()"
            data-test="arrival-detail__chick-birthdate"
          />
          <mat-datepicker-toggle matIconSuffix [for]="chickBirthDatePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #chickBirthDatePicker></mat-datepicker>
          <mat-error *ngIf="formGroup.controls.chickBirthDate.invalid">
            {{ 'validation-error.required' | translate }}
          </mat-error>
        </mat-form-field>

        @if (formGroup.controls.chickBirthDate.value) {
          <mat-form-field class="flex__child--auto">
            <mat-label for="productionPeriodStartDate">{{
              'arrival-detail.production-period-start-date' | translate
            }}</mat-label>
            <input
              id="productionPeriodStartDate"
              matInput
              formControlName="productionPeriodStartDate"
              [matDatepicker]="productionPeriodStartDatePicker"
              [min]="minDeviation"
              [max]="maxDeviation"
              placeholder="{{ 'arrival-detail.production-period-start-date' | translate }}"
              (focus)="productionPeriodStartDatePicker.open()"
              data-test="arrival-detail__production-period-start-date"
            />
            <mat-datepicker-toggle
              matIconSuffix
              [for]="productionPeriodStartDatePicker"
            ></mat-datepicker-toggle>
            <mat-datepicker touchUi #productionPeriodStartDatePicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field class="flex__child--auto">
            <mat-label for="productionPeriodAge">{{
              'arrival-detail.age-start-production-period' | translate
            }}</mat-label>
            <input
              id="productionPeriodAge"
              matInput
              readonly
              formControlName="productionPeriodAge"
              data-test="arrival-detail__production-period-days"
            />
            <span matTextSuffix class="form-field-suffix">{{
              'arrival-detail.days' | translate
            }}</span>
          </mat-form-field>
        }
        <mat-form-field class="flex__child--auto">
          <mat-label for="arrivalDate">{{ 'arrival-detail.arrival-date' | translate }}</mat-label>
          <input
            id="arrivalDate"
            matInput
            formControlName="arrivalDate"
            [matDatepicker]="arrivalDatePicker"
            [min]="minArrivalDate"
            [max]="maxArrivalDate"
            placeholder="{{ 'arrival-detail.arrival-date' | translate }}"
            (focus)="arrivalDatePicker.open()"
            data-test="arrival-detail__arrival-date"
          />
          <mat-datepicker-toggle matIconSuffix [for]="arrivalDatePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #arrivalDatePicker></mat-datepicker>
          <mat-error *ngIf="formGroup.controls.arrivalDate.invalid">
            {{ 'validation-error.required' | translate }}
          </mat-error>
        </mat-form-field>
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'arrival-detail.breed' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            formControlName="breedId"
            data-test="arrival-detail__breed"
          >
            @for (breed of breeds; track breed.id) {
              <mat-option [value]="breed.id">
                {{ breed.name }}
              </mat-option>
            }
          </mat-select>
          <mat-error *ngIf="formGroup.controls.breedId.invalid">
            {{ 'validation-error.required' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label for="amountOfHens"
            >{{ 'arrival-detail.amount-of-hens' | translate }} ♀</mat-label
          >
          <input
            id="amountOfHens"
            matInput
            agrNumber
            [step]="1"
            formControlName="amountOfHens"
            placeholder="{{ 'arrival-detail.amount-of-hens' | translate }}"
            data-test="arrival-detail__amount-of-hens"
          />
          @if (formGroup.controls.amountOfHens.errors?.required) {
            <mat-error>
              {{ 'validation-error.required' | translate }}
            </mat-error>
          }
          @if (formGroup.controls.amountOfHens.hasError('min')) {
            <mat-error>
              {{ 'arrival-detail.minimum-amount-of-hens-error' | translate }}
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label for="henWeightInGrams"
            >{{ 'arrival-detail.hen-weight' | translate }} ♀</mat-label
          >
          <input
            id="henWeightInGrams"
            matInput
            agrNumber
            [step]="0.01"
            inputmode="decimal"
            data-test="arrival-detail__henWeightInGrams"
            formControlName="henWeightInGrams"
            placeholder="{{ 'arrival-detail.hen-weight' | translate }}"
          />
          <span matTextSuffix class="form-field-suffix">g</span>
          <mat-error *ngIf="formGroup.controls.henWeightInGrams.hasError('min')">
            {{ 'arrival-detail.hen-weight-error' | translate }}
          </mat-error>
          <mat-error *ngIf="formGroup.controls.henWeightInGrams.errors?.arrivalWeightInvalid">
            {{ 'arrival-detail.hen-weight-comparison-error' | translate }}
          </mat-error>
        </mat-form-field>

        @if (isBreeder) {
          <mat-form-field class="flex__child--auto">
            <mat-label>{{ 'arrival-detail.feed-system-hens' | translate }} ♀</mat-label>
            <mat-select
              [hideSingleSelectionIndicator]="true"
              formControlName="feedSystemHens"
              data-test="arrival-detail__feed-system-hens"
            >
              @for (feedSystem of feedSystems; track feedSystem) {
                <mat-option [value]="feedSystem">
                  {{ 'feed-systems.' + feedSystem | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-error *ngIf="formGroup.controls.feedSystemHens.invalid">
              {{ 'validation-error.required' | translate }}
            </mat-error>
          </mat-form-field>
        }

        @if (isBreeder) {
          <mat-slide-toggle
            formControlName="showRoosterFields"
            color="primary"
            class="flex__child--auto spacing--margin-bottom"
            data-test="arrival-detail__show-rooster-fields"
          >
            {{ 'arrival-detail.show-rooster-fields' | translate }}
          </mat-slide-toggle>
        }

        @if (isBreeder && formGroup.controls.showRoosterFields.value) {
          <mat-form-field class="flex__child--auto">
            <mat-label for="amountOfRoosters"
              >{{ 'arrival-detail.amount-of-roosters' | translate }} ♂</mat-label
            >
            <input
              id="amountOfRoosters"
              matInput
              agrNumber
              [step]="1"
              formControlName="amountOfRoosters"
              placeholder="{{ 'arrival-detail.amount-of-roosters' | translate }}"
              data-test="arrival-detail__amount-of-roosters"
            />
            <mat-error *ngIf="formGroup.controls.amountOfRoosters.hasError('min')">
              {{ 'arrival-detail.minimum-amount-of-roosters-error' | translate }}
            </mat-error>
          </mat-form-field>
        }

        @if (isBreeder && formGroup.controls.showRoosterFields.value) {
          <mat-form-field class="flex__child--auto">
            <mat-label for="roosterWeightInGrams"
              >{{ 'arrival-detail.rooster-weight' | translate }} ♂</mat-label
            >
            <input
              id="roosterWeightInGrams"
              matInput
              agrNumber
              [step]="0.01"
              inputmode="decimal"
              data-test="arrival-detail__roosterWeightInGrams"
              formControlName="roosterWeightInGrams"
              placeholder="{{ 'arrival-detail.rooster-weight' | translate }}"
            />
            <span matTextSuffix class="form-field-suffix">g</span>
            <mat-error *ngIf="formGroup.controls.roosterWeightInGrams.hasError('min')">
              {{ 'arrival-detail.rooster-weight-error' | translate }}
            </mat-error>
          </mat-form-field>
        }

        @if (!isBreeder) {
          <mat-form-field class="flex__child--auto">
            <mat-label>{{ 'arrival-detail.egg-marketing-standard' | translate }}</mat-label>
            <mat-select
              [hideSingleSelectionIndicator]="true"
              formControlName="eggMarketingStandard"
              data-test="arrival-detail__egg-marketing-standard"
            >
              @for (eggMarketingStandard of eggMarketingStandards; track eggMarketingStandard.id) {
                <mat-option [value]="eggMarketingStandard.id">
                  {{ eggMarketingStandard.id }} -
                  {{ 'egg-marketing-standards.' + eggMarketingStandard.name | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-error *ngIf="formGroup.controls.eggMarketingStandard.invalid">
              {{ 'validation-error.required' | translate }}
            </mat-error>
          </mat-form-field>
        }

        @if (!isBreeder) {
          <mat-form-field class="flex__child--auto">
            <mat-label>{{ 'arrival-detail.housing-system' | translate }}</mat-label>
            <mat-select
              [hideSingleSelectionIndicator]="true"
              formControlName="housingSystem"
              data-test="arrival-detail__housing-system"
            >
              @for (housingSystem of housingSystems; track housingSystem.id) {
                <mat-option [value]="housingSystem.id">
                  {{ housingSystem.id }} -
                  {{ 'housing-systems.' + housingSystem.name | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-error *ngIf="formGroup.controls.housingSystem.invalid">
              {{ 'validation-error.required' | translate }}
            </mat-error>
          </mat-form-field>
        }

        @if (!isBreeder && isOrganicOrFreeRange()) {
          <mat-form-field class="flex__child--auto">
            <mat-label for="timeInFreeRange">{{
              'arrival-detail.time-in-free-range' | translate
            }}</mat-label>
            <input
              id="timeInFreeRange"
              matInput
              agrNumber
              [step]="1"
              formControlName="timeInFreeRange"
              placeholder="{{ 'arrival-detail.time-in-free-range' | translate }}"
              data-test="arrival-detail__time-in-free-range"
            />
            <span matTextSuffix class="form-field-suffix">%</span>
            <mat-error
              *ngIf="
                formGroup.controls.timeInFreeRange.hasError('min') ||
                formGroup.controls.timeInFreeRange.hasError('max')
              "
            >
              {{ 'arrival-detail.time-in-free-range-error' | translate }}
            </mat-error>
          </mat-form-field>
        }

        @if (isBreeder && formGroup.controls.showRoosterFields.value) {
          <mat-form-field class="flex__child--auto">
            <mat-label>{{ 'arrival-detail.feed-system-roosters' | translate }} ♂</mat-label>
            <mat-select
              [hideSingleSelectionIndicator]="true"
              formControlName="feedSystemRoosters"
              data-test="arrival-detail__feed-system-roosters"
            >
              @for (feedSystem of feedSystems; track feedSystem) {
                <mat-option [value]="feedSystem">
                  {{ 'feed-systems.' + feedSystem | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'arrival-detail.hatchery' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            formControlName="hatcheryId"
            data-test="arrival-detail__hatchery"
          >
            @for (hatchery of hatcheries(); track hatchery.id) {
              <mat-option [value]="hatchery.id">
                {{ hatchery.name }}
              </mat-option>
            }
          </mat-select>
          <mat-error *ngIf="formGroup.controls.hatcheryId.invalid">
            {{ 'validation-error.required' | translate }}
          </mat-error>
        </mat-form-field>

        @if (isBreeder) {
          <mat-form-field class="flex__child--auto">
            <mat-label>{{ 'arrival-detail.drink-system' | translate }}</mat-label>
            <mat-select
              [hideSingleSelectionIndicator]="true"
              formControlName="drinkSystem"
              data-test="arrival-detail__drink-system"
            >
              @for (drinkSystem of drinkSystems; track drinkSystem) {
                <mat-option [value]="drinkSystem">
                  {{ 'drink-systems.' + drinkSystem | translate }}
                </mat-option>
              }
            </mat-select>
            <mat-error *ngIf="formGroup.controls.drinkSystem.invalid">
              {{ 'validation-error.required' | translate }}
            </mat-error>
          </mat-form-field>
        }

        @if (isBreeder) {
          <mat-form-field class="flex__child--auto">
            <mat-label>{{ 'arrival-detail.nest' | translate }}</mat-label>
            <mat-select
              [hideSingleSelectionIndicator]="true"
              formControlName="nest"
              data-test="arrival-detail__nest"
            >
              @for (nest of nests; track nest) {
                <mat-option [value]="nest">
                  {{ 'nests.' + nest | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @if (isBreeder) {
          <mat-form-field class="flex__child--auto">
            <mat-label>{{ 'arrival-detail.rearing-organization' | translate }}</mat-label>
            <mat-select
              [hideSingleSelectionIndicator]="true"
              formControlName="rearingOrganizationId"
              data-test="arrival-detail__rearing-organization"
            >
              @for (item of rearingOrganizations(); track item.id) {
                <mat-option [value]="item.id">
                  {{ item.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'arrival-detail.transport-distance' | translate }}</mat-label>
          <input
            id="transportDistance"
            matInput
            agrNumber
            [step]="1"
            formControlName="transportDistance"
            aria-label="{{ 'arrival-detail.transport-distance' | translate }}"
            placeholder="{{ 'arrival-detail.transport-distance' | translate }}"
            data-test="arrival-detail__transport-distance"
          />
          <span matTextSuffix class="form-field-suffix">km</span>
          <mat-error
            *ngIf="
              formGroup.controls.transportDistance.hasError('min') ||
              formGroup.controls.transportDistance.hasError('max')
            "
          >
            {{ 'arrival-detail.transport-distance-error' | translate }}
          </mat-error>
        </mat-form-field>

        @if (!isBreeder) {
          <mat-form-field class="flex__child--auto">
            <mat-label>{{ 'arrival-detail.bedding-type' | translate }}</mat-label>
            <mat-select
              [hideSingleSelectionIndicator]="true"
              formControlName="beddingType"
              data-test="arrival-detail__bedding-type"
            >
              @for (beddingType of beddingTypes; track beddingType) {
                <mat-option [value]="beddingType">
                  {{ 'bedding-types.' + beddingType | translate }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @if (!isBreeder) {
          <mat-form-field class="flex__child--auto">
            <mat-label>{{ 'arrival-detail.bedding-amount' | translate }}</mat-label>
            <input
              id="beddingAmount"
              matInput
              agrNumber
              [step]="0.01"
              formControlName="beddingAmount"
              aria-label="{{ 'arrival-detail.bedding-amount' | translate }}"
              placeholder="{{ 'arrival-detail.bedding-amount' | translate }}"
              data-test="arrival-detail__bedding-amount"
            />
            <span matTextSuffix class="form-field-suffix">kg</span>
            <mat-error *ngIf="formGroup.controls.beddingAmount.hasError('min')">
              {{ 'arrival-detail.bedding-amount-error' | translate }}
            </mat-error>
          </mat-form-field>
        }
      </div>

      <div class="flex--column">
        <mat-label>{{ 'arrival-detail.input-mode' | translate }}</mat-label>
        <mat-radio-group formControlName="inputMode">
          <mat-radio-button
            data-test="arrival-detail__input-day"
            class="text--small"
            color="primary"
            [value]="'PerDay'"
          >
            {{ 'arrival-detail.input-mode-per-day' | translate }}
          </mat-radio-button>
          <mat-radio-button
            data-test="arrival-detail__input-week"
            class="text--small"
            color="primary"
            [value]="'PerWeek'"
          >
            {{ 'arrival-detail.input-mode-per-week' | translate }}
          </mat-radio-button>
          <mat-radio-button
            data-test="arrival-detail__input-advanced"
            class="text--small"
            color="primary"
            [value]="'Advanced'"
          >
            {{ 'arrival-detail.input-mode-advanced' | translate }}
          </mat-radio-button>
        </mat-radio-group>
        <a
          class="text--right"
          data-test="arrival-detail__advanced-link"
          (click)="viewMode = 'advanced-input-settings'"
        >
          @if (formGroup.controls.inputMode.value === 'Advanced') {
            {{ 'arrival-detail.advanced-link' | translate }}
          }
        </a>
      </div>
    }

    @if (viewMode === 'advanced-input-settings') {
      <div class="flex--column">
        <a (click)="viewMode = 'general-flock-data'" data-test="arrival-detail__back-link">
          {{ 'arrival-detail.back-to-general-data' | translate }}
        </a>
        <h4>{{ 'arrival-detail.advanced-settings-title' | translate }}</h4>

        <div formArrayName="advancedSettings" class="spacing--margin-top">
          @for (control of advancedSettings().controls; track $index; let i = $index) {
            <app-advanced-setting
              [formControlName]="i"
              [settingName]="advancedSettingsArray[i]"
              [value]="control.value"
            >
            </app-advanced-setting>
          }
        </div>
      </div>
    }
  </div>
</agr-form-dialog>
